module.exports = __webpack_public_path__ + "static/img/02003C_4_C_20230710_fit.396ed25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02003C_4_C_20230710_fit.png
// module id = LHmi
// module chunks = 0